import { BehaviorSubject } from 'rxjs';
import { IEntity } from '@/shared/interfaces/entity.interface';
import { IQueueWrapUp } from '@/shared/interfaces/queue-wrap-up.interface';
import { logger } from '@/services/logger.service';

export interface IState {
  allEntities: IEntity[];
  activeEntities: IEntity[];
  callNoteId: string;
  isDialerActive: boolean;
  wrapUpQueue: IQueueWrapUp;
  prevInboxChatId: string;
  prevHistoryChatId: string;
}

export class State {
  public static state$: BehaviorSubject<IState> = new BehaviorSubject({
    allEntities: null,
    activeEntities: null,
    callNoteId: null,
    prevInboxChatId: null,
    prevHistoryChatId: null,
    isDialerActive: null,
    wrapUpQueue: null,
  });

  public static setState(data: Partial<IState>): void {
    logger.log('[State] Set state', data);
    const previousState = State.state$.getValue();

    State.state$.next({ ...previousState, ...data });
  }
}
